<template>
    <div class="vue_flex vue_column">
        <div class="cont_wrapper">
            <div class="cont_wrapper_sx">
                <div class="shaixuan_left">
                    <div class="shaixuan_item h">
                        <div class="shaixuan_item_con">
                            <img class="shaixuan_item_icon" src="../../../../../assets/ym/tjsj@2x.png" alt="" />
                            <div class="shaixuan_item_tit">统计时间</div>
                        </div>
                        <el-date-picker v-model="listQuery.time" type="datetimerange" range-separator=""
                            start-placeholder="" end-placeholder="" value-format="timestamp" class="vue_flex_item"
                            placeholder="选择日期">
                        </el-date-picker>
                    </div>
                    <div class="shaixuan_item h">
                        <div class="shaixuan_item_con">
                            <img class="shaixuan_item_icon" src="../../../../../assets/ym/qd@2x.png" alt="" />
                            <div class="shaixuan_item_tit">渠道</div>
                        </div>
                        <el-select v-model="listQuery.type" placeholder="请选择" class="vue_flex_item">
                            <el-option v-for="item in qudaooptions" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div class="shaixuan_item h">
                        <div class="shaixuan_item_con">
                            <img class="shaixuan_item_icon" src="../../../../../assets/ym/dp@2x.png" alt="" />
                            <div class="shaixuan_item_tit">店铺</div>
                        </div>
                        <el-select v-model="listQuery.shopid" placeholder="请选择" class="vue_flex_item">
                            <el-option v-for="item in dpList" :key="item.shopid" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>

                <div class="shaixuan_btns">
                    <div class="shaixuan_btn1 h" @click="qingchu">清除</div>
                    <div class="shaixuan_btn2 h" @click="search">查询</div>
                </div>
            </div>
            <div class="home_title">
                <div class="vue_flex">
                    <div class="home_tit vue_relative h" :class="tabs.id === tabsId ? 'home_tit_active' : 'home_tit_activenot'
                        " v-for="(tabs, tabsIndex) in tabsList" :key="tabsIndex" @click="tabsClick(tabs)">
                        <p>{{ tabs.title }}</p>
                        <div class="home_solid vue_absolute" v-if="tabs.id === tabsId"></div>
                    </div>
                </div>
                <!-- <div class="home_right">
          <div class="home_right_1">
            <div>日</div>
            <img src="../../../../../assets/ym/xl@2x.png" alt="" />
          </div>
          <img
            class="home_right_2"
            src="../../../../../assets/ym/gd@2x.png"
            alt=""
          />
        </div> -->
            </div>

            <div style="margin-top: 25px" class="vue-font-PingFang-500 color_35 font22 line_height_22">
                利润总览看板-{{ tabsId === 1 ? "支付口径" : "发货口径" }}
            </div>

            <linkboxs :list="linkList" @itemClick="linkboxsClick"></linkboxs>

            <div id="myChart"></div>

            <div class="home_title">
                <div class="home_tit">
                    利润总览看板-{{ tabsId === 1 ? "支付口径" : "发货口径" }}
                </div>
            </div>
            <template>
                <el-table :data="tableData" style="width: 100%"
                    :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#333' }"
                    :span-method="(...arg) => strategySpanMethod(...arg, tableData)" key="paycaliber">
                    <el-table-column fixed prop="riqi" label="统计时间" align="center"></el-table-column>
                    <el-table-column prop="qudaoName" label="渠道" align="center"></el-table-column>
                    <el-table-column prop="name" label="店铺名称" align="center"></el-table-column>
                    <el-table-column prop="maolirun" :label="tabsId == 1 ? '毛利（支付）' : '毛利（发货）'"
                        align="center"></el-table-column>
                    <el-table-column prop="maolilv" :label="tabsId == 1 ? '毛利率 %（支付）' : '毛利率 %（发货）'"
                        align="center"></el-table-column>
                    <el-table-column prop="yewulirun" label="业务利润（支付）" align="center"></el-table-column>
                    <el-table-column prop="yewulirunlv" label="业务利润率 %（支付）" align="center"></el-table-column>
                    <el-table-column prop="xiaoshoushouru" label="销售收入（去退）" align="center"></el-table-column>
                    <el-table-column prop="xiaoshounum" label="销售数量" align="center"></el-table-column>
                    <el-table-column prop="shouhoumoney" label="售后金额" align="center"></el-table-column>
                    <el-table-column prop="tuikuailv" label="退款率 %（支付）" align="center"></el-table-column>
                    <el-table-column prop="fahuoqiantuikuanjine" label="发货前退款金额" align="center"></el-table-column>
                    <el-table-column prop="fahuobegintuikuanlv" label="发货前退款率 %（支付）" align="center"></el-table-column>
                    <el-table-column prop="fahuohoutuikuanjine" label="发货后退款金额" align="center"></el-table-column>
                    <el-table-column prop="fahuoendtuikuanlv" label="发货后退款率 %（支付）" align="center"></el-table-column>
                    <el-table-column prop="yewuchengben" label="业务成本（利润）" align="center"></el-table-column>
                    <el-table-column prop="xianshangguanggaotoufangfeiyong" label="线上广告投放费用"
                        align="center"></el-table-column>
                    <el-table-column prop="guanggaobi" label="广告投放费比" align="center"></el-table-column>
                    <el-table-column prop="pingtaigudingkoudian" label="平台固定扣点" align="center"></el-table-column>
                    <el-table-column prop="pingtaiqitakoukuan" label="平台其它扣款" align="center"></el-table-column>
                    <el-table-column prop="pingtaiyingxiaohuodong" label="平台营销活动" align="center"></el-table-column>
                    <el-table-column prop="teshudanfeiyong" label="特殊单费用" align="center"></el-table-column>

                    <el-table-column prop="baozhuangfeiyong" label="包装费用" align="center"></el-table-column>
                    <el-table-column prop="kuaidifeiyong" label="快递费用" align="center"></el-table-column>
                    <el-table-column prop="zengpinfeiyong" label="赠品费用" align="center"></el-table-column>
                    <el-table-column prop="paishefeiyong" label="拍摄费用" align="center"></el-table-column>
                    <el-table-column prop="cangchufeiyong" label="仓储费用" align="center"></el-table-column>
                    <el-table-column prop="guanlifeiyong" label="管理费用" align="center"></el-table-column>
                    <el-table-column prop="kaifafeiyong" label="开发费用" align="center"></el-table-column>
                    <el-table-column prop="rengongzhichu" label="人工支出" align="center"></el-table-column>
                </el-table>
            </template>
            <!-- <pagination :total="total" :page.sync="listQuery1.page" :limit.sync="listQuery1.limit"
                @pagination="getdataList" /> -->
        </div>
    </div>
</template>
<script>
import Cookies from "js-cookie";
import * as echarts from "echarts";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import linkboxs from "@/components/linkdata/index";
import DonMessage from "@/utils/message";

export default {
    components: { Pagination, linkboxs },
    data() {
        return {
            dpList: [],
            qudaooptions: [
                { value: "1", label: "淘宝" },
                { value: "2", label: "京东" },
                { value: "3", label: "拼多多" },
            ],
            total: 0,
            listQuery: {
                time: [],
                type: "",
                shopid: "",
            },
            listQuery1: {
                page: 1,
                limit: 10,
                leixing: "",
            },
            tabsId: 1,
            tabsList: [
                { id: 1, title: "支付口径" },
                { id: 2, title: "发货口径" },
            ],

            charts: "",
            opinionData: ["3", "2", "4", "4", "5"],
            linkList: [
                {
                    tit: "业务利润",
                    num: "",
                    bi: "业务利润率",
                    img: require("../../../../../assets/ym/ywlrl.png"),
                    height: 181,
                    width: 367,
                },
                {
                    tit: "销售收入",
                    num: "",
                    bi: "销售数量       ",
                    bihou: "销售订单数    ",
                    img: require("../../../../../assets/ym/xssr.png"),
                    height: 181,
                    width: 367,
                },
                {
                    tit: "销售金额",
                    num: "",
                    bi: "售后数量  ",
                    img: require("../../../../../assets/ym/gtkl@2x.png"),
                    height: 181,
                    width: 367,
                },
                {
                    tit: "业务成本（利润）",
                    num: "",
                    img: require("../../../../../assets/ym/ywcb.png"),
                    height: 181,
                    width: 367,
                },
                {
                    tit: "费用",
                    num: "",
                    img: require("../../../../../assets/ym/fy.png"),
                    height: 181,
                    width: 367,
                },
                {
                    tit: "退款率",
                    num: "7234.87",
                    bi: "销售数量       ",
                    bihou: "销售订单数    ",
                    img: require("../../../../../assets/ym/tkl.png"),
                    height: 181,
                    width: 367,
                },
            ],

            userObj: {},
            tableData: [],
            riqiSpanArr: [],
        };
    },
    mounted() { },
    created() {
        this.getList();
        this.getdpListFun();
        this.getzftb();
        this.getdataList();
    },
    methods: {
        getSpanArr(data, spanKey) {
            var spanArr = [];
            var pos = "";
            for (var i = 0; i < data.length; i++) {
                if (i === 0) {
                    spanArr.push(1);
                    pos = 0;
                } else {
                    // 判断当前元素与上一个元素是否相同
                    if (data[i][spanKey] === data[i - 1][spanKey]) {
                        spanArr[pos] += 1;
                        spanArr.push(0);
                    } else {
                        spanArr.push(1);
                        pos = i;
                    }
                }
            }
            return spanArr;
        },
        // 合并单元格函数
        strategySpanMethod: function (
            { row, column, rowIndex, columnIndex },
            data
        ) {
            if (columnIndex !== 0) return;
            // data 就是从这里动态传过来的, column.property是表头的key
            var spanArr = this.getSpanArr(data, column.property);
            const _row = spanArr[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
                rowspan: _row,
                colspan: _col,
            };
        },
        async getdataList() {
            let params = {
                page: this.listQuery1.page,
                limit: this.listQuery1.limit,
                leixing: this.tabsId == 1 ? "zhichu" : "fahuo",
                starttime: this.listQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "",
                endtime: this.listQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "",
                iscaiwu: 1
            };
            const res = await this.$http.get(this.$urls.lirunribao_excel, params);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.total = res.allData.lenth
            res.allData.forEach((dateItem) => {
                const { riqi, qudao } = dateItem;
                // 遍历每个渠道
                qudao.forEach((channelItem) => {
                    const { name: qudaoName, shopList } = channelItem;
                    // 渠道无店铺时，生成空店铺行（保证日期合并完整性）
                    if (shopList.length === 0) {
                        this.tableData.push({
                            riqi,
                            qudaoName,
                            name: "-",
                            xiaoshoushouru: "0.00",
                            xiaoshounum: 0,
                            dingdannum: 0,
                            maolilv: "-",
                            maolirun: "-",
                            yewu: "-",
                        });
                    } else {
                        // 有店铺时，遍历店铺生成行
                        shopList.forEach((shopItem) => {
                            this.tableData.push({
                                riqi,
                                qudaoName,
                                ...shopItem,
                                // name: shopItem.name,
                                // xiaoshoushouru: shopItem.xiaoshoushouru,
                                // xiaoshounum: shopItem.xiaoshounum,
                                // dingdannum: shopItem.dingdannum,
                                // maolilv: shopItem.maolilv,
                                // maolirun: shopItem.maolirun,
                                // yewu: shopItem.yewu,
                            });
                        });
                    }
                });
            });
        },

        initTableData() { },
        search() {
            if (this.tabsId == 1) {
                this.getList();
                this.getzftb();
            } else {
                this.getfahuoList();
                this.getfhtb();
            }
            this.tableData = [];
            this.getdataList();
        },
        linkboxsClick(msg) {
            console.log('msg--->', msg);
            this.$nextTick(function () {
                this.drawLine("myChart", msg.tubiao);
            });
        },
        async getfhtb() {
            const res = await this.$http.post(this.$urls.lirunribao_fahuo_echart, {
                type: this.listQuery.type,
                shopid: this.listQuery.shopid,
                iscaiwu: 1
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            for (let key of this.linkList) {
                if (key.tit == "业务利润") {
                    key.tubiao = res.yewulirunEcharts;
                }
                if (key.tit == "销售收入") {
                    key.tubiao = res.xiaoshoushouruEcharts;
                }
                if (key.tit == "销售金额") {
                    key.tubiao = res.xiaoshoushouruEcharts;
                }
                if (key.tit == "业务成本（利润）") {
                    key.tubiao = res.yewuchengbenEcharts;
                }
                if (key.tit == "费用") {
                    key.tubiao = res.feiyongEcharts;
                }
                if (key.tit == "退款率") {
                    key.tubiao = res.tuikuailvEcharts;
                }
            }
            this.$nextTick(function () {
                this.drawLine("myChart", res.yewulirunEcharts);
            });
        },
        async getzftb() {
            const res = await this.$http.post(this.$urls.lirunribao_zhifu_echart, {
                type: this.listQuery.type,
                shopid: this.listQuery.shopid,
                iscaiwu: 1
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            for (let key of this.linkList) {
                if (key.tit == "业务利润") {
                    key.tubiao = res.yewulirunEcharts;
                }
                if (key.tit == "销售收入") {
                    key.tubiao = res.xiaoshoushouruEcharts;
                }
                if (key.tit == "销售金额") {
                    key.tubiao = res.xiaoshoushouruEcharts;
                }
                if (key.tit == "业务成本（利润）") {
                    key.tubiao = res.yewuchengbenEcharts;
                }
                if (key.tit == "费用") {
                    key.tubiao = res.feiyongEcharts;
                }
                if (key.tit == "退款率") {
                    key.tubiao = res.tuikuailvEcharts;
                }
            }
            this.$nextTick(function () {
                this.drawLine("myChart", res.yewulirunEcharts);
            });
        },

        async getfahuoList() {
            let params = {
                type: this.listQuery.type,
                shopid: this.listQuery.shopid,
                starttime:
                    this.listQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "",
                endtime:
                    this.listQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "",
                iscaiwu: 1
            };
            const res = await this.$http.post(this.$urls.lirunribao_fahuo, params);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            for (let key of this.linkList) {
                if (key.tit == "业务利润") {
                    key.num = res.yewulirun;
                    key.bi = "业务利润率" + res.yewulirunlv + '%';
                }
                if (key.tit == "销售收入") {
                    key.num = res.xiaoshoushouru;
                    key.bi = "销售数量" + res.xiaoshounum;
                    key.bihou = "销售订单数" + res.dingdannum;
                }
                if (key.tit == "销售金额") {
                    key.num = res.xiaoshoushouru || 0;
                    key.bi = "售后数量" + res.shouhoushuliang;
                }
                if (key.tit == "业务成本（利润）") {
                    key.num = res.yewuchengben;
                }
                if (key.tit == "费用") {
                    key.num = res.feiyong;
                }
                if (key.tit == "退款率") {
                    key.num = res.tuikuailv;
                    key.bi = "发货前退款率" + res.fahuobegintuikuanlv + '%';
                    key.bihou = "发货后退款率" + res.fahuoendtuikuanlv + '%';
                }
            }
        },
        async getList() {
            let params = {
                type: this.listQuery.type,
                shopid: this.listQuery.shopid,
                starttime:
                    this.listQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "",
                endtime:
                    this.listQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "",
                iscaiwu: 1
            };
            const res = await this.$http.post(this.$urls.lirunribao_zhifu, params);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            console.log('res--->', res);
            for (let key of this.linkList) {
                if (key.tit == "业务利润") {
                    key.num = res.yewulirun;
                    key.bi = "业务利润率" + res.yewulirunlv + '%';
                }
                if (key.tit == "销售收入") {
                    key.num = res.xiaoshoushouru;
                    key.bi = "销售数量" + res.xiaoshounum;
                    key.bihou = "销售订单数" + res.dingdannum;
                }
                if (key.tit == "销售金额") {
                    key.num = res.xiaoshoushouru || 0;
                    key.bi = "售后数量" + res.shouhoushuliang;
                }
                if (key.tit == "业务成本（利润）") {
                    key.num = res.yewuchengben;
                }
                if (key.tit == "费用") {
                    key.num = res.feiyong;
                }
                if (key.tit == "退款率") {
                    key.num = res.tuikuailv;
                    key.bi = "发货前退款率" + res.fahuobegintuikuanlv + '%';
                    key.bihou = "发货后退款率" + res.fahuoendtuikuanlv + '%';
                }
            }
        },
        qingchu() {
            this.listQuery = {
                time: [],
                type: "",
                shopid: "",
            };
            this.getList();
        },
        // 店铺列表
        async getdpListFun() {
            const res = await this.$http.get(this.$urls.getshoplist, {
                page: 1,
                limit: 10000,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.dpList = res.list;
        },
        drawLine(id, item) {
            this.charts = echarts.init(document.getElementById(id));
            this.charts.setOption({
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: [""],
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "12%",
                    containLabel: true,
                },

                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: item.x,
                },
                yAxis: {
                    type: "value",
                },

                series: [
                    {
                        name: "近七日",
                        type: "line",
                        stack: "总量",
                        data: item.y,
                    },
                ],
            });
        },

        tabsClick(row) {
            if (this.tabsId === row.id) return;
            if (row.id == 1) {
                this.getList();
                this.getzftb();
            } else {
                this.getfahuoList();
                this.getfhtb();
            }
            this.tabsId = row.id;
        },
    },
};
</script>

<style lang="scss" scoped>
#myChart {
    width: 1508px;
    height: 300px;
}

.home_links {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 20px;

    .home_item {
        height: 105px;
        margin-bottom: 26px;
        margin-right: 13px;
        background-size: 294px 105px;
        padding: 25px;

        .home_item_t1 {
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 19px;
            color: #232323;
        }

        .home_item_t2 {
            font-family: PingFang SC;
            font-weight: 800;
            font-size: 27px;
            color: #232323;
        }

        &:nth-of-type(5n) {
            margin-right: 0;
        }
    }
}

.home_title {
    width: 100%;
    height: 55px;
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .home_tit {
        p {
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 26px;
            margin-right: 47px;
        }

        .home_solid {
            width: 34px;
            height: 3px;
            background: #195cf8;
            border-radius: 2px;
            bottom: -12px;
            left: 50%;
            margin-left: -38px;
        }
    }

    .home_tit_active {
        color: rgba(25, 92, 248, 1);
    }

    .home_tit_activenot {
        color: rgba(35, 35, 35, 1);
    }

    .home_right {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;

        .home_right_2 {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            margin-left: 10px;
        }

        .home_right_1 {
            padding: 0 10px;
            width: 108px;
            height: 45px;
            background: #f4f5f9;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
        }
    }
}

.shaixuan_btns {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;

    .shaixuan_btn1 {
        width: 132px;
        height: 55px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #999999;
        text-align: center;
        line-height: 55px;
    }

    .shaixuan_btn2 {
        margin-left: 25px;
        width: 131px;
        height: 54px;
        background: #195cf8;
        border-radius: 10px;
        text-align: center;
        line-height: 55px;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
    }
}

.cont_wrapper {
    padding: 25px;

    .cont_wrapper_sx {
        width: 1527px;
        height: 71px;
        background: #f5f5f5;
        border-radius: 10px;
        padding: 0 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .shaixuan_left {
            display: flex;
            flex-direction: row;
            justify-content: start;
            align-items: center;
        }

        .shaixuan_item {
            width: 350px;
            height: 54px;
            background: #ffffff;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            margin-right: 22px;

            .shaixuan_item_con {
                display: flex;
                flex-direction: row;
                justify-content: start;
                align-items: center;

                .shaixuan_item_tit {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #232323;
                }

                .shaixuan_item_sel {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #999999;
                }

                .shaixuan_item_arr {
                    width: 13px;
                    height: 8px;
                    margin-left: 10px;
                }

                .shaixuan_item_icon {
                    width: 29px;
                    height: 24px;
                    margin-right: 10px;
                }
            }
        }
    }
}

.shaixuan_item {
    /deep/ .el-date-editor {
        border: none !important;
        text-align: right;
        font-size: 18px;
        width: 196px;
    }

    /deep/ .el-input__icon {
        display: none;
    }

    .el-input /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }

    .el-input /deep/.el-input__prefix {
        display: none !important;
    }

    .el-select /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/dashboard/profit/index.vue